import { Dispatch } from 'react';
import { GridData } from 'components/common/grid/';
import { GridState } from 'components/common/grid'; // или импортируй тип отдельно

export const applyGridData = (
    data: { rows: GridData; results: number },
    dispatch: Dispatch<Partial<GridState>>,
): void => {
    dispatch({
        gridData: data.rows,
        totalCount: data.results,
        dataLoadingDone: true,
        gridReorderLoading: false,
    });
};
